import { Lock, LockOpen } from "lucide-react";
import { useLingui } from "@lingui/macro";
import { cn } from "@app/lib/utils";
import { STATE_LABELS, type DatasetState } from "@app/utils/reference-dataset";

/**
 * « Référence · en constitution » / « Référence · scellée » — nothing for a work dataset.
 *
 * Slate, not a warning hue: being a reference is a status, not a risk. The two states differ by
 * icon and weight, so they read apart without colour.
 */
export default function DatasetStateBadge({
  state,
  className,
}: {
  state: DatasetState | null | undefined;
  className?: string;
}) {
  const { t } = useLingui();
  if (!state || state === "work") return null;
  const sealed = state === "sealed";
  const Icon = sealed ? Lock : LockOpen;
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-1 rounded-full border px-2 py-0.5 text-xs",
        sealed
          ? "border-slate-300 bg-slate-100 font-semibold text-slate-700"
          : "border-dashed border-slate-300 bg-white font-medium text-slate-600",
        className,
      )}
    >
      <Icon className="h-3 w-3" aria-hidden="true" />
      {t(STATE_LABELS[state])}
    </span>
  );
}
